module.exports = __webpack_public_path__ + "static/whitepaper_download_qatch-9657df78babfd5f847d9103d9871bd89.jpg";